/**
 * 页面级 i18n 映射表
 * 因为可能回存在跨页面的 i18n 依赖，所以这里加一个配置 Map
 */
const i18nKeyMap = new Map([
  ['lending-detail', 'lending'],
  ['my-lending', 'lending'],
  ['staking-detail', 'staking'],
  ['staking-list', 'staking'],
  ['staking-reward', 'staking'],
  ['mission-x-detail', 'mission-x'],
  ['10-BTC-Giveaway', '10-BTC-Giveaway'],
  ['Labor-activity', 'Labor-activity'],
  ['verify-starterVerification', 'verify'],
  ['launchpad-detail', 'launchpad'],
  ['launchpad-history', 'launchpad'],
  ['voting-detail', 'voting'],
  ['sub-account-asset-transfer', 'sub-account'],
  ['sub-account-transfer-history', 'sub-account'],
  ['nft-goods-detail', 'nft'],
  ['nft-home', 'nft'],
  ['nft-usercenter', 'nft'],
  ['nft-marketplace', 'nft'],
  ['nft-collectible', 'nft'],
  ['nft-creator', 'nft'],
  ['referral-history', 'referral'],
  ['nft-sale', 'nft'],
  ['institution-verification', 'verify'],
  ['kol-competition-poming', 'kol-competition'],
  ['kol-competition-sweet-chocolate', 'kol-competition'],
  ['kol-competition-chart-pilot', 'kol-competition'],
  ['kol-competition-songajisesang', 'kol-competition'],
  ['kol-competition-coin-gwangbu', 'kol-competition'],
  ['nftmarket-goods-detail', 'nft'],
  ['nftmarket-home', 'nft'],
  ['nftmarket-usercenter', 'nft'],
  ['nftmarket-marketplace', 'nft'],
  ['nftmarket-collectible', 'nft'],
  ['nftmarket-creator', 'nft'],
  ['nftmarket-sale', 'nft'],
  ['futures-competition-type', 'futures-competition'],
  ['WTCL-2022-Individual', 'WTCL'],
  ['2022-blackfriday', '2022-blackfriday'],
  ['2022-blackfriday-2022-wagmi-box', '2022-blackfriday'],
  ['promotion-type', 'bonus-giveaway'],
  ['2022-christmasday', '2022-christmasday'],
  ['futures-lucky-draw', 'futures-lucky-draw'],
  ['p2p/ads-manage', 'p2p'],
  ['p2p-index', 'p2p'],
  ['p2p', 'p2p'],
  ['p2p/ad-orders', 'p2p'],
  ['p2p/create-ad', 'p2p'],
  ['p2p/trading-detail', 'p2p'],
  ['p2p/myprofile', 'p2p'],
  ['p2p/ad-detail', 'p2p'],
  ['p2p/ads-merchant', 'p2p'],
  ['p2p/merchant-apply', 'p2p'],
  ['p2p-merchant-apply-form', 'p2p'],
  ['p2p-merchant-apply-form-lang', 'p2p'],
  ['academy-index', 'academy'],
  ['academy-detail', 'academy'],
  ['academy-articles', 'academy'],
  ['BWTC',  'teams-trading'],
  ['BMXstaketolist/stakelist',  'BMXstaketolist'],
  ['cards', 'cards'],
  ['cards-index', 'cards'],
  ['cards/trade', 'cards'],
  ['cards-trade', 'cards'],
  ['cards-order-detail', 'cards'],
  ['cards-trade-result', 'cards'],

]);

export default i18nKeyMap;

export const i18nPageList = new Set([
  'nft',
  'test',
  'teams-trading',
  'p2p',
  'p2p-ads-merchant',
  'academy',
  'vip',
  'messages',
  'vip-portal',
  'BMXstaketolist',
  'cards',
]);
